/**
 * set and initialize slider modules
 */
class Lightbox {

  /**
   * create a new lightbox
   */
  constructor(element) {
    this.elementClone = element.cloneNode();

    this.revealId = 'galleryReveal';
    this.reveal = document.getElementById(this.revealId);
    this.content = document.getElementById('galleryLightbox');

    this.open();
  }

  open() {
    this.content.innerHTML = '';
    this.content.appendChild(this.elementClone);
    jQuery(`#${this.revealId}`).foundation('open');
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./scripts/util/Lightbox.js